import { OptionsObject, SnackbarKey, SnackbarMessage, useSnackbar, VariantType } from 'notistack';
import { useEffect } from 'react';

const defaultOptions: OptionsObject = {
  preventDuplicate: true,
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
  style: {
    whiteSpace: 'pre-line',
  },
};

type TNotistack = any; // eslint-disable-line

export const Notistack: TNotistack = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    Notistack.enqueueSnackbar = (message: SnackbarMessage, variant?: VariantType, options?: OptionsObject) => {
      enqueueSnackbar(message, {
        ...defaultOptions,
        ...options,
        variant,
      });
    };

    Notistack.successMessage = (message: string) => {
      enqueueSnackbar(message, {
        ...defaultOptions,
        variant: 'success',
      });
    };

    Notistack.infoMessage = (message: string) => {
      enqueueSnackbar(message, {
        ...defaultOptions,
        variant: 'info',
      });
    };

    Notistack.generalError = (
      message = 'Something went wrong. \nPlease try again later or contact your system administrator.',
    ) => {
      enqueueSnackbar(message, {
        ...defaultOptions,
        variant: 'error',
      });
    };
  }, [enqueueSnackbar]);

  useEffect(() => {
    Notistack.closeSnackbar = (key?: SnackbarKey) => {
      closeSnackbar(key);
    };
  }, [closeSnackbar]);

  return null;
};
